import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';

interface SimpleDonutChartProps {
  data: { label: string; value: number; color: string }[];
  height?: number;
  formatValue?: (value: number) => string;
}

export function SimpleDonutChart({
  data,
  height = 300,
  formatValue = v => v.toLocaleString('fr-FR'),
}: SimpleDonutChartProps) {
  if (data.length === 0) return null;

  const chartData = data.map(item => ({
    name: item.label,
    value: item.value,
    color: item.color,
  }));

  const total = chartData.reduce((sum, item) => sum + item.value, 0);

  return (
    <div className="relative">
      <ResponsiveContainer width="100%" height={height}>
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            innerRadius="60%"
            outerRadius="80%"
            paddingAngle={2}
            dataKey="value"
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip
            contentStyle={{
              backgroundColor: 'white',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              padding: '8px 12px',
            }}
            formatter={value => {
              const num = Number(value);
              return [formatValue(num), `${((num / total) * 100).toFixed(1)}%`];
            }}
            labelStyle={{
              color: '#374151',
              fontWeight: 600,
              marginBottom: '4px',
            }}
          />
        </PieChart>
      </ResponsiveContainer>
      
      {/* Legend */}
      <div className="mt-4 flex flex-wrap justify-center gap-4">
        {chartData.map((entry, index) => (
          <div key={index} className="flex items-center gap-2">
            <div
              className="h-3 w-3 rounded-full"
              style={{ backgroundColor: entry.color }}
            />
            <span className="text-sm text-neutral-600">
              {entry.name}: {formatValue(entry.value)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
